// Read server-rendered cards so prices, availability, and product links stay in sync with Shopify.
async function loadAllSupplies(page) {
  const grid = page.querySelector('.supplies-grid');
  const status = page.querySelector('.supplies-status');
  const pagination = page.querySelector('.supplies-pagination');
  const empty = page.querySelector('.supplies-empty');
  const seenPages = new Set();
  const seenProducts = new Set([...grid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
  let next = page.dataset.nextUrl;
  try {
    while (next) {
      const url = new URL(next, location.href);
      if (url.origin !== location.origin || seenPages.has(url.href)) throw new Error('Invalid supplies pagination');
      seenPages.add(url.href);
      const response = await fetch(url.href, { cache: 'no-store', signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error('Supplies page unavailable');
      const freshPage = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.supplies-page');
      if (!freshPage) throw new Error('Missing supplies catalog');
      for (const card of freshPage.querySelectorAll('[data-product-id]')) {
        if (!seenProducts.has(card.dataset.productId)) {
          seenProducts.add(card.dataset.productId);
          grid.append(card);
        }
      }
      next = freshPage.dataset.nextUrl;
    }
    status.textContent = `${seenProducts.size} ${seenProducts.size === 1 ? 'product' : 'products'}`;
    empty.hidden = seenProducts.size !== 0;
    pagination.hidden = true;
  } catch (_) {
    status.textContent = 'Some supplies could not be loaded. Browse the next supplies page to continue.';
    const nextLink = pagination.querySelector('a:last-child');
    if (nextLink && next) nextLink.href = next;
  }
}

const suppliesPage = document.querySelector('.supplies-page');
if (suppliesPage) loadAllSupplies(suppliesPage);
